import { createAsyncThunk } from '@reduxjs/toolkit'

import { getTokenByHash, refreshToken, refreshTokenB2C } from '@app/api'
import config, { vars } from '@app/config'
import { setCookie } from '@app/services'
import { getActiveB2CCookieNames, getAuthMode } from '@app/utils'
import { byteLength, MAX_TOKEN_BYTES, requestJwtFromNative } from '@app/utils'
import { hasFeature, WebViewFeature } from '@app/utils/webview/hasFeature'

let nativeRefreshPromise: Promise<{ token: string } | null> | null = null

export const refreshTokenThunk = createAsyncThunk('auth', async () => {
  const { isBackOfficeTokenMode } = getAuthMode()
  const { accessTokenCookie } = getActiveB2CCookieNames()

  if (
    config.identity.isWebView &&
    hasFeature(WebViewFeature.DelegatedJwtExchange)
  ) {
    if (!nativeRefreshPromise) {
      nativeRefreshPromise = requestJwtFromNative()
        .then(({ access_token }) => {
          if (access_token) {
            const size = byteLength(access_token)
            if (size > MAX_TOKEN_BYTES) {
              throw new Error(
                `Access token size ${size} bytes exceeds limit ${MAX_TOKEN_BYTES} bytes`
              )
            }
            setCookie(
              isBackOfficeTokenMode ? vars.b2b_access_token : accessTokenCookie,
              access_token
            )
            return { token: access_token, refreshToken: null }
          }
          return null
        })
        .catch((error) => {
          console.error(
            'Failed to get token from native app, falling back.',
            error
          )
          return null
        })
        .finally(() => {
          nativeRefreshPromise = null
        })
    }

    const result = await nativeRefreshPromise
    if (result) {
      return result
    }
  }

  if (isBackOfficeTokenMode) {
    const { result } = await refreshToken()
    return result
  }
  return await refreshTokenB2C()
})

export const getURLTokenByHashThunk = createAsyncThunk(
  'getUrlTokenByHash',
  async (hash: string) => {
    const res = await getTokenByHash(hash)

    return { access_token: res, urlToken: hash }
  }
)
